import React, { useState, useEffect } from "react";
import {
  Button,
  TextField,
  Typography,
  Container,
  Select,
  MenuItem,
  InputLabel,
  Box,
  Stack,
} from "@mui/material";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { toast } from "react-toastify";
import axios from "axios";
import { serverUrl } from "../../server";
import Cookies from "js-cookie";
import { useParams, useNavigate } from "react-router-dom";

const defaultTheme = createTheme();

const UpdateBenne = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [immat, setImmat] = useState('');
  const [proprioId, setProprioId] = useState('');
  const [propriosOptions, setPropriosOptions] = useState([]);
  const [loading, setLoading] = useState(true);

  const getProprios = async () => {
    const token = Cookies.get('jwt');
    try {
      const response = await axios.get(`${serverUrl}/api/proprio/getproprios`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      setPropriosOptions(response.data.proprios);
    } catch (error) {
      console.error(error);
      toast.error('Erreur lors du chargement des propriétaires');
    }
  };

  const getBenneDetails = async () => {
    const token = Cookies.get('jwt');
    try {
      const response = await axios.get(`${serverUrl}/api/benne/getbenne/${id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      const benne = response.data;
      setImmat(benne.immat);
      setProprioId(benne.proprio_id);
    } catch (error) {
      console.error(error);
      toast.error('Erreur lors du chargement des détails de la benne');
      navigate('/dashboard/bennes');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getProprios();
    getBenneDetails();
  }, [id]);

  const handleSubmit = async (event) => {
    event.preventDefault();
    const token = Cookies.get('jwt');
    const data = {
      immat: immat,
      proprio_id: proprioId,
    };

    try {
      const response = await axios.post(
        `${serverUrl}/api/benne/updatebenne/${id}`,
        data,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.data.success) {
        toast.success('Benne mise à jour avec succès', {
          position: "bottom-center",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "dark",
        });
        navigate('/dashboard/benne');
      } else {
        toast.error(response.data.message || 'Erreur lors de la mise à jour');
      }
    } catch (error) {
      console.error(error);
      toast.error('Erreur lors de la mise à jour de la benne');
    }
  };

  if (loading) {
    return (
      <Container component="main" maxWidth="xs">
        <Box sx={{ mt: 3, textAlign: 'center' }}>
          <Typography>Chargement...</Typography>
        </Box>
      </Container>
    );
  }

  return (
    <ThemeProvider theme={defaultTheme}>
      <Container component="main" maxWidth="xs">
        <Box sx={{ mt: 3, mb: 3 }}>
          <Typography component="h1" variant="h5" align="center" gutterBottom>
            Modifier une Benne
          </Typography>
        </Box>
        <Box component="form" onSubmit={handleSubmit} noValidate>
          <Stack spacing={3}>
            <TextField
              required
              fullWidth
              id="immat"
              label="Immatriculation"
              name="immat"
              autoFocus
              value={immat}
              onChange={(e) => setImmat(e.target.value)}
            />
            <Box>
              <InputLabel id="proprioId-label">Propriétaire</InputLabel>
              <Select
                labelId="proprioId-label"
                id="proprioId"
                value={proprioId}
                onChange={(e) => setProprioId(e.target.value)}
                fullWidth
              >
                {propriosOptions.map((proprio) => (
                  <MenuItem key={proprio.id} value={proprio.id}>
                    {proprio.nom}
                  </MenuItem>
                ))}
              </Select>
            </Box>
            <Box sx={{ mt: 2 }}>
              <Button
                type="submit"
                fullWidth
                variant="contained"
                color="primary"
                size="large"
              >
                Mettre à jour
              </Button>
            </Box>
          </Stack>
        </Box>
      </Container>
    </ThemeProvider>
  );
};

export default UpdateBenne;
        